<div class="payment-page">


<h2>
My Payments
</h2>



<div
class="empty"
*ngIf="!payment || payment.length===0">

No payment details available

</div>




<div
class="payment-grid">


<div
class="payment-card"

*ngFor="let item of payment">



<!-- SERVICE -->

<div class="service">

<h3>
{{item.service_name}}
</h3>

</div>






<!-- PAYMENT DETAILS -->


<div class="payment-section">


<h4>
Payment Details
</h4>



<p>

<strong>
Payment Type :
</strong>

{{item.payment_type}}

</p>




<p>

<strong>
Total Amount :
</strong>

₹{{item.total_amount}}

</p>



</div>







<!-- ADVANCE DETAILS -->


<div

class="amount-section"

*ngIf="item.payment_type==='Advance'">


<h4>
Advance Payment
</h4>



<p>

<strong>
Paid Amount :
</strong>

₹{{item.advance_amount}}

</p>



<p>

<strong>
Remaining Amount :
</strong>

₹{{item.remaining_amount}}

</p>



</div>






<!-- POSTPAID DETAILS -->


<div

class="amount-section"

*ngIf="item.payment_type==='Postpaid'">


<h4>
Payment Due
</h4>


<p>

<strong>
Remaining Amount :
</strong>

₹{{item.remaining_amount}}

</p>


</div>








<!-- STATUS -->


<div class="status-section">


<span

class="status"

[ngClass]="{


'paid':
item.payment_status==='Paid'
||
item.payment_status==='Completed',


'pending':
item.payment_status==='Pending'


}">


{{item.payment_status}}


</span>


</div>







<!-- PAY BUTTON -->


<div class="action-buttons">


<button

class="pay-btn"

(click)="payNow(item)"

*ngIf="

item.payment_status==='Pending'
||
(
item.payment_type==='Advance'
&&
item.remaining_amount>0
)

">

Pay Now

</button>



</div>





</div>


</div>


</div>